import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver errors (from Elfsight widgets)
const suppressedErrors = ['ResizeObserver loop'];
const origError = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === 'string' && suppressedErrors.some(e => msg.includes(e))) return true;
  return origError ? origError(msg, ...args) : false;
};
window.addEventListener('error', (e) => {
  if (suppressedErrors.some(s => e.message?.includes(s))) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
